import type { TransactionPredicate } from './types';

export const hasAttachment: TransactionPredicate = (transaction) => Boolean(transaction.attachment);
